export interface IPeriodDialog {
	title: string;
	btnYes: string;
	begin?: Date;
	end?: Date;
}
